import React, { useState } from 'react';
import { UserMessage } from './UserMessage';
import { useTranslation } from 'react-i18next';
import AccurityButton from '../../buttons/components/AccurityButton';
import Stack from '@mui/material/Stack';
export var UserMessageContainer = function (_a) {
    var _b = _a.messages, messages = _b === void 0 ? [] : _b, onDismiss = _a.onDismiss, onDismissAll = _a.onDismissAll;
    var t = useTranslation()[0];
    var _c = useState(null), expandedMsg = _c[0], setExpandedMsg = _c[1];
    var isMessageCollapsed = function (msg) {
        if (messages.length < 5) {
            return false;
        }
        return expandedMsg !== msg;
    };
    return (React.createElement("div", { className: "userMessageContainer" },
        messages.length > 1 && (React.createElement(Stack, null,
            React.createElement(AccurityButton, { "aria-label": "userMessageContainer__dismissAll", onClick: onDismissAll, variant: "contained", color: "secondary" }, t('userMessage.dismissAll')))),
        messages.map(function (msg) { return (React.createElement(UserMessage, { key: msg.id, id: msg.id, title: msg.title, message: msg.message, onDismiss: function () { return onDismiss(msg); }, collapsed: isMessageCollapsed(msg), onMouseEnter: function () { return setExpandedMsg(msg); }, onMouseLeave: function () { return setExpandedMsg(null); } })); })));
};
export default UserMessageContainer;
//# sourceMappingURL=UserMessageContainer.js.map